import { useEffect, useState } from "react";
import UserEdit from "../components/UserEdit";
import { User } from "../../../../shared/types";
import { useNavigate, useParams } from "react-router-dom";
import { PreviewType } from "../components/EditMode";
import { LinearProgress, Box } from "@material-ui/core";
import { UserActions } from "../../actions/user";

const UserPage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);
  const params = useParams();
  useEffect(() => {
    if (params.id) fetchData();
    else setLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    const response = await UserActions.get({
      id: params.id,
    });
    setUser(response.data);
    if (!response.failed) setLoading(false);
  };
  const onSave = async (user: User) => {
    //TODO: Make loading overlay and use that one for when page is loaded.
    //TODO: Snackbar for confirmation ( modal? )
    setLoading(true);
    if (params.id) {
      await UserActions.put(user);
    } else {
      const response = await UserActions.post(user);
      if (!response.failed) navigate(`/backend/user/${response.id}`);
    }
    setUser(user);
    setLoading(false);
  };
  const onCancel = () => {};
  const onPreview = (user: User, type: PreviewType) => {};

  return loading ? (
    <Box sx={{ width: "100%" }}>
      <LinearProgress />
    </Box>
  ) : (
    <UserEdit
      user={user}
      onSave={onSave}
      onCancel={onCancel}
      onPreview={onPreview}
    />
  );
};

export default UserPage;
